import React, { ReactElement } from 'react';
import classnames from 'classnames';
import styles from './CheckboxInputGroupAccessibleWDP.module.scss';

interface iProps {
  options: string[];
  selectedValues: string[];
  onSelectionChange: (selected: string[]) => void;
  title: string;
}

const CheckboxInputGroupAccessibleWDP = ({ options, title, selectedValues, onSelectionChange }: iProps): ReactElement => {
  const isAllSelected = (options?.length > 0 && selectedValues?.length === options?.length);

  const handleSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      onSelectionChange(options);
    } else {
      onSelectionChange([]);
    }
  };

  const handleCheckboxChange = (value: string) => {
    if (selectedValues?.includes(value)) {
      onSelectionChange(selectedValues.filter((item) => item !== value));
    } else {
      onSelectionChange([...selectedValues, value]);
    }
  };

  return (
    <div>
      <div>
        <label
          className={styles.container}
          htmlFor={title}>
          <input
            id={title}
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSelectAllChange} />
          <span className={classnames({ [styles.tickContainer]: true })} />
          Select all/Deselect all
        </label>
      </div>
      <div>
        {options.map((option) => (
          <React.Fragment key={option}>
            <hr />
            <label
              className={styles.container}
              htmlFor={option}>
              <input
                type="checkbox"
                id={option}
                name={option}
                value={option}
                checked={selectedValues?.includes(option)}
                onChange={(e) => handleCheckboxChange(e.target.value)}
                disabled={false}
              />
              <span className={classnames({ [styles.tickContainer]: true, [styles.tickContainerSelected]: selectedValues?.includes(option) })} />
              <span className={styles.body}>{option}</span>
            </label>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CheckboxInputGroupAccessibleWDP;
